/**
 * @file index.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Thursday, 24th October 2019 6:26:20 pm
 * @copyright 2015 - 2019 SKAT LLC, Delive LLC
 */

// @flow
import AddressInput from './AddressInput'
import CheckBox from './CheckBox'
import PhoneInput from './PhoneInput'
import Select from './Select'
import Slider from './Slider'
import DateTime from './DateTime'
import Button from './Button'
import ReferenceSelect from './ReferenceSelect'
import IndicatorInput from './IndicatorInput'

export { AddressInput, CheckBox, PhoneInput, Select, DateTime, ReferenceSelect, Button, IndicatorInput, Slider }
